import { PokerGameFormatType, PokerGameModel, PokerGameSNGStatusType } from 'mvppoker-portal-common/api'
import MathUtils from 'mvppoker-portal-common/utils/MathUtils'
import React from 'react'
import { classNames } from '../../../../utils/cssUtils'
import './RoomsTableItem.scss'

interface Props {
	format: PokerGameFormatType,
	room: PokerGameModel
	isSelected: boolean
	onClick: () => void
}

export default ({ format, room, isSelected, onClick }: Props) => {
	const { maxPlayers } = room.config
	const cs = classNames('room-table-item', { selected: isSelected })

	if (format === PokerGameFormatType.Sng){
		const isPlaying = room.sngData?.status === PokerGameSNGStatusType.Playing
		const activePlayers = room.players.length

		const prizes = room.config.sngConfig!.prizeMultipliers.map(p => `${MathUtils.MultiplyNumbers(p, '100')}%`).join(' • ')

		return (
			<div className={cs} onClick={onClick}>
				<span className='room-name'>{room.config.roomName}</span>
				<div className='room-data'>
					<div>
						<span>Type</span>
						<span>|</span>
						<span>{room.config.type}</span>
					</div>
					<div>
						<span>Status</span>
						<span>|</span>
						<span>{isPlaying ? `${activePlayers} PLAYING` : `OPEN ${activePlayers}/${maxPlayers}`}</span>
					</div>
					<div>
						<span>Dealer</span>
						<span>|</span>
						<span>{room.dealer?.info.name ?? '-'}</span>
					</div>
					<div>
						<span>Prizes</span>
						<span>|</span>
						<span>{prizes}</span>
					</div>
					<div>
						<span>Buy In</span>
						<span>|</span>
						<span>${room.config.minimumBuyIn}</span>
					</div>
				</div>
			</div>
		)
	}

	const totalPot = room?.statistics?.totalPotAmount ?? '0'
	const gamesInPot = `${room?.statistics?.gamesPlayed ?? 0}`
	const avgPot = MathUtils.IsBiggerThanZero(gamesInPot) ? MathUtils.Format(MathUtils.DivideNumbers(gamesInPot, totalPot)) : '0.0'
	const activePlayers = room.players.length

	return (
		<div className={cs} onClick={onClick}>
			<span className='room-name'>{room.config.roomName}</span>
			<div className='room-data'>
				<div>
					<span>Type</span>
					<span>|</span>
					<span>{room.config.type}</span>
				</div>
				<div>
					<span>Stakes</span>
					<span>|</span>
					<span>${room.config.smallBlindAmount}/${room.config.bigBlindAmount}</span>
				</div>
				<div>
					<span>Avg.</span>
					<span>|</span>
					<span>${avgPot}</span>
				</div>
				<div>
					<span>Dealer</span>
					<span>|</span>
					<span>{room.dealer?.info.name ?? '-'}</span>
				</div>
				<div>
					<span>Players</span>
					<span>|</span>
					<span>{activePlayers}/{maxPlayers}</span>
				</div>
			</div>
		</div>
	)
}
